
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Layer_1","clip-path":"url(#clip0_1270_1512)","fill":"#5B5BE7"}},[_c('path',{attrs:{"id":"Vector","d":"M6.689 6.49A3.365 3.365 0 005.7 8.883c0 .45.09.888.257 1.3.167.413.424.786.732 1.095.642.644 1.49.991 2.388.991.899 0 1.746-.347 2.388-.991a3.365 3.365 0 00.989-2.395c0-.45-.09-.888-.257-1.3a3.153 3.153 0 00-.732-1.095c-1.271-1.274-3.492-1.274-4.763 0h-.013z"}}),_c('path',{attrs:{"id":"Vector_2","d":"M17.063 8.202c-.45.038-.835.399-.835.862a7.294 7.294 0 01-2.722 5.64c-.102-.129-.192-.245-.308-.36a5.752 5.752 0 00-8.19 0c-.155.154-.283.321-.412.476A7.3 7.3 0 011.72 9.013c-.051-4.017 3.21-7.3 7.229-7.3h.025a.823.823 0 00.822-.838.845.845 0 00-.847-.836C4.019.039 0 4.069 0 9.013 0 12 1.464 14.627 3.698 16.262c.449.334.937.618 1.45.862 1.156.541 2.44.863 3.8.863a8.855 8.855 0 004.02-.966 8.993 8.993 0 004.93-8.009c0-.463-.373-.81-.835-.81z"}}),_c('path',{attrs:{"id":"Vector_3","d":"M11.324 4.506h2.182v2.19c0 .424.347.772.77.772.424 0 .771-.348.771-.773V4.506h2.183a.774.774 0 000-1.545h-2.183V.773a.774.774 0 00-.77-.773.774.774 0 00-.77.773V2.96h-2.183a.774.774 0 000 1.545z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1270_1512"}},[_c('rect',{attrs:{"width":"18","height":"18","fill":"#fff"}})])])])
          )
        }
      }
    